@if (banners$ | async; as banners) {
  @let shouldTurnOnCarousel = isMoreThanOne(banners);

  <p-carousel
    [showNavigators]="shouldTurnOnCarousel"
    [autoplayInterval]="5000"
    [circular]="shouldTurnOnCarousel"
    [numScroll]="1"
    [numVisible]="1"
    [showIndicators]="shouldTurnOnCarousel"
    [value]="banners">
    <ng-template
      #item
      let-banner>
      <div class="relative aspect-[1920/400]">
        <app-image-thumbnail
          [rounded]="false"
          size="full">
          <img
            [alt]="banner.file.alt"
            [fill]="true"
            [ngSrc]="banner.file.url"
            class="object-contain" />
        </app-image-thumbnail>
      </div>
    </ng-template>
  </p-carousel>
} @else {
  <div class="px-8 pb-8 xl:px-16">
    <app-spinner-filled />
  </div>
}
